export default __webpack_public_path__ + "static/media/Error.6061fc1a.jpg";